import { useLocation } from "react-router";

/**
 * Hooks that returns query params.
 */
const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};

export default useQuery;
